var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_6496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8596 8.92982V6.94736C16.8596 6.42158 16.6507 5.91734 16.2789 5.54555C15.9071 5.17377 15.4029 4.9649 14.8771 4.9649H6.9473C6.42152 4.9649 5.91727 5.17377 5.54549 5.54555C5.17371 5.91734 4.96484 6.42158 4.96484 6.94736V14.8772C4.96484 15.403 5.17371 15.9072 5.54549 16.279C5.91727 16.6508 6.42152 16.8596 6.9473 16.8596H8.92976",
    stroke: "#4F5662",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1V1.00991M4.96491 1V1.00991M8.92982 1V1.00991M12.8947 1V1.00991M1 4.96491V4.97482M1 8.92982V8.93974M1 12.8947V12.9046M10.0789 10.0263L19 13L15.0351 14.9825L13.0526 18.9474L10.0789 10.0263Z",
    stroke: "#4F5662",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_6496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrop);
export default __webpack_public_path__ + "static/media/icon-drop.999acdd1772fd827b3c2447fbe1d4cc5.svg";
export { ForwardRef as ReactComponent };